app.service("ProductService", ['$rootScope', '$http', 'AcquiredService', function ($rootScope, $http, AcquiredService) {

    const service = this;

    const siteHelper = $rootScope.site_helper;

    const modelConstructor = $rootScope.model_constructor;

    let didLogOut = false;

    this.BasicProductModel = modelConstructor.extend(AcquiredService.BasicAcquiredModel, {
        is_product_model: true,
        isValidAcquiredObject: isValidAcquiredObject,
        applyItemHandler: applyItemHandler,
        onItemsBuiltHandler: onItemsBuiltHandler,
        handleSharedProducts: null,

        parent_category_group_id: null,
        parent_category_group_type_id: null,
        parent_category_id: null,
        product: null,
        can_use_placeholder_products: false,
        shared_products: null,

        birthChoice: function (values) {
            return new service.ProductChoice(values);
        }

    });

    this.BasicProductModelFactory = modelConstructor.extend(modelConstructor.ModelFactory, {
        birth: function (values) {
            return new service.BasicProductModel(values);
        },
        applyModelVariation: applyModelVariation,
        onModelVariationApplied: onModelVariationApplied

    });


    this.ProductChoice = modelConstructor.extend(AcquiredService.AcquiredChoice, {
        is_product_choice: true,

        getSubmitRangeID: function () {
            return this.root.submit_range_id ? this.root.submit_range_id : this.root.request_range_id;
        },
        finalPrice: function (optionTermIDs) {
            return service.finalPrice(this.root);
        },
        displayPrice: function (optionTermIDs) {
            return $rootScope.service.currency.currencyPrice(this.root.finalPrice(optionTermIDs));
        },
        formatPrice: function (priceParams, emptyIfZero) {
            return $rootScope.service.currency.currencyFormat(this.root.displayPrice(priceParams), emptyIfZero);
        },
        cloneClass: function () {
            return service.ProductChoice;
        }
    });

    function applyModelVariation(model) {

        this.super(model);
        applyGenericVariation(model);
    }

    function onModelVariationApplied(model) {

        this.super(model);
        model.beta_category_name = model.parent_category_id === "handle" ? "Categories" : null;
        createPlaceholderProducts(model);
    }

    function createPlaceholderProducts(model) {

        let amount = 0;
        if (model.is_single_item_model) {
            if (!model.product) {
                amount = 1;
            }
        } else {
            const choiceList = model.choiceList()
            if (choiceList.length === 0) {
                amount = 24;
            }
        }
        if (amount === 0) {
            return
        }

        model.can_use_placeholder_products = true;

        const simulateAcquiredObjects = {};
        for (let i = 0; i < amount; i++) {
            const simulateProductID = "placeholder_product_" + i;
            simulateAcquiredObjects[simulateProductID] = {id: simulateProductID, disabled: true, is_placeholder: true}
        }
        model.buildAcquiredChoices(simulateAcquiredObjects);
    }


    function isValidAcquiredObject(acquiredObject) {
        const model = this.root;
        if (model.filter_by_colour_required) {
            const colourID = model.colour_id;
            if (colourID && !acquiredObject.tags.includes(colourID)) {
                return false;
            }
        }
        return true;
    }

    function applyItemHandler(product) {

        const model = this.root;

        product.option_term_ids = {};
        product.option_term_values = {};

        product.selection_inputs = {};
        product.selection_values = {};

        product.current_non_standard_surcharge = product.non_standard_surcharge;
        product.current_surcharge = product.surcharge;
        product.local_option_term_config = [];
        product.refresh_sub_product_required = false;

        product.prevent_non_standard_size = product.hasOwnProperty('allow_non_standard_size') && !product.allow_non_standard_size;
        product.have_small_large_products = false;
        product.height_break_point = 0;
        product.allow_zero_value = false;
        if(model.parent_category_cache){
            product.submit_range_id = model.parent_category_cache.submit_range_id ?? null;
        }

        if (!product.hasOwnProperty('base_price')) {
            product.base_price = product.price;
        }

        if (!product.name) {
            product.name = product.api_code;
        }

        product.base_component_id = (model.base_component_id ? model.base_component_id : null);
        product.parent_category_group_ids = [];
        product.parent_category_ids = [];
        if (model.parent_category_group_id) {
            product.parent_category_group_ids.push(model.parent_category_group_id);
        }
        if (model.parent_category_id) {
            product.parent_category_ids.push(model.parent_category_id);
        }
        product.alpha_category_ids = [];
        product.beta_category_ids = [];

        siteHelper.applyValues(product, {

            activeSubProduct: function () {
                return product;
            },
            isRefreshSubProductRequired: function () {
                if (product.refresh_sub_product_required) {
                    product.refresh_sub_product_required = false;
                    return true;
                }
                return false
            },

            sizedProduct: function () {
                if (!product.have_small_large_products) {
                    return product;
                }
                if (!product.height_break_point || !product.height || product.height < product.height_break_point) {
                    return product.small_product;
                }
                return product.large_product;

            },

            getOptionProductModel: function () {
                const sizedProduct = product.sizedProduct();
                const optionProductModel = sizedProduct.option_product_model;
                if (optionProductModel && optionProductModel.known_state === $rootScope.navigation_model.href) {
                    return optionProductModel;
                }
                const variationIDs = $rootScope.navigation_model.state_ids;
                const optionProductVariationID = $rootScope.service.option_product.createOptionProductVariationID(variationIDs);
                if (optionProductModel && optionProductModel.option_product_variation_id === optionProductVariationID) {
                    return optionProductModel;
                }
                $rootScope.service.option_product.createOptionProductModel(product, sizedProduct, variationIDs);
                return sizedProduct.option_product_model;
            }
        });
    }

    function onItemsBuiltHandler() {
        const model = this.root;

        const isSingleItemModel = model.is_single_item_model;
        if (isSingleItemModel) {
            const choiceList = model.choiceList();
            if (choiceList.length > 0) {
                model.product = choiceList[0];
            }
        } else {
            if (model.handleSharedProducts) {
                model.handleSharedProducts()
            }
        }

        populateProductParentCategoryGroupIDs(model);
        populateProductParentCategoryIDs(model);
        populateProductAlphaCategoryIDs(model);
        populateProductBetaCategoryIDs(model);
    }

    function populateProductParentCategoryGroupIDs(model) {
        if (model.parent_category_group_cache) {
            return;
        }
        const parentGroupCategories = model.base_component_cache ? model.base_component_cache.parent_category_group : null;
        for (let choiceID in model.choices) {
            const product = model.choices[choiceID];
            if (product.parent_category_group_ids.length) {
                return;
            }
        }
        for (let choiceID in model.choices) {
            const product = model.choices[choiceID];
            for (let index in product.tags) {
                const tag = product.tags[index];
                if (parentGroupCategories && parentGroupCategories[tag] && !product.parent_category_group_ids.includes(tag)) {
                    product.parent_category_group_ids.push(tag);
                }
            }
        }
    }

    function populateProductParentCategoryIDs(model) {
        if (model.parent_category_cache) {
            return;
        }
        const parentCategories = model.base_component_cache ? model.base_component_cache.parent_category : null;
        for (let choiceID in model.choices) {
            const product = model.choices[choiceID];
            if (product.parent_category_ids.length) {
                return;
            }
        }
        for (let choiceID in model.choices) {
            const product = model.choices[choiceID];
            for (let index in product.tags) {
                const tag = product.tags[index];
                if (parentCategories && parentCategories[tag] && !product.parent_category_ids.includes(tag)) {
                    product.parent_category_ids.push(tag);
                }
            }
        }
    }

    function populateProductAlphaCategoryIDs(model) {
        const alphaCategories = model.parent_category_cache ? model.parent_category_cache.alpha_category : null;
        if (!alphaCategories) {
            return
        }
        for (let choiceID in model.choices) {
            const product = model.choices[choiceID];
            if (product.alpha_category_ids.length) {
                return;
            }
        }
        for (let choiceID in model.choices) {
            const product = model.choices[choiceID];
            let haveTags = false;
            for (let index in product.tags) {
                const tag = product.tags[index];
                if (alphaCategories[tag] && tag !== "all" && tag !== "other" && !product.alpha_category_ids.includes(tag)) {
                    product.alpha_category_ids.push(tag);
                    haveTags = true;
                }
            }
            if (!haveTags && alphaCategories.other) {
                product.alpha_category_ids.push("other");
            }
            if (alphaCategories.all) {
                product.alpha_category_ids.push("all");
            }
        }
    }

    function populateProductBetaCategoryIDs(model) {
        const betaCategories = model.parent_category_cache ? model.parent_category_cache.beta_category : null;
        if (!betaCategories) {
            return
        }
        for (let choiceID in model.choices) {
            const product = model.choices[choiceID];
            if (product.beta_category_ids.length) {
                return;
            }
        }
        for (let choiceID in model.choices) {
            const product = model.choices[choiceID];
            let haveTags = false;
            for (let index in product.tags) {
                const tag = product.tags[index];
                if (betaCategories[tag] && tag !== "all" && tag !== "other" && !product.beta_category_ids.includes(tag)) {
                    product.beta_category_ids.push(tag);
                    haveTags = true;
                }
            }
            if (!haveTags && betaCategories.other) {
                product.beta_category_ids.push("other");
            }
            if (betaCategories.all) {
                product.beta_category_ids.push("all");
            }
        }
    }

    function applyGenericVariation(model) {

        const variationIDs = model.variation_ids;
        const baseComponentID = model.base_component_id ? model.base_component_id : (variationIDs.base_component_id ? variationIDs.base_component_id : null);
        const navigationRequestRangeID = variationIDs.request_range_id;
        const siteRangeID = variationIDs.site_range_id;
        const colourID = variationIDs.colour_id;
        const styleID = variationIDs.style_id;
        const relatedProductID = variationIDs.product_id;
        let parentCategoryGroupID = variationIDs.parent_category_group_id;
        let parentCategoryGroupTypeID = variationIDs.parent_category_group_type_id;
        const parentCategoryID = variationIDs.parent_category_id;

        const baseComponentCache = baseComponentID ? $rootScope.model.cache_local_server.component[baseComponentID] : null;
        let parentCategoryGroupCache = null;
        let parentCategoryCache = null;
        if (baseComponentCache) {
            if (parentCategoryID && baseComponentCache.parent_category) {
                parentCategoryCache = baseComponentCache.parent_category[parentCategoryID];
                if(baseComponentCache.parent_category_group){
                    for(let parentCategoryCacheID in baseComponentCache.parent_category_group){
                        let checkParentCategoryCache = baseComponentCache.parent_category_group[parentCategoryCacheID]
                        if((checkParentCategoryCache.children ?? []).includes(parentCategoryID) && (!parentCategoryGroupID || (parentCategoryGroupID === checkParentCategoryCache.id))){
                            parentCategoryGroupID = checkParentCategoryCache.id;
                            parentCategoryGroupTypeID = checkParentCategoryCache.group_id ?? null;
                            parentCategoryGroupCache = checkParentCategoryCache;
                            break;
                        }
                    }
                }

            }
        }

        const primaryCache = parentCategoryCache ? parentCategoryCache : baseComponentCache;
        let requestRangeID = null;
        let requestEndpoint = null;
        let apiCode = null;
        let filterByColourRequired = false;
        if (primaryCache) {

            const allRequestParams = primaryCache.request_params;
            const requestRangeIDs = allRequestParams ? Object.keys(allRequestParams) : [];
            if (requestRangeIDs.length === 1) {
                requestRangeID = requestRangeIDs[0];
            } else if (navigationRequestRangeID && allRequestParams[navigationRequestRangeID]) {
                requestRangeID = navigationRequestRangeID;
            }
            if (requestRangeID) {
                const requestParams = allRequestParams[requestRangeID];
                const styleRequestParams = styleID && requestParams.style && requestParams.style[styleID] ? requestParams.style[styleID] : null;
                apiCode = requestParams.api_code;
                if (styleRequestParams && styleRequestParams.api_code) {
                    apiCode = styleRequestParams.api_code;
                }

                if (apiCode) {
                    const colourTagRequired = !!requestParams.colour_tag_required;
                    const relatedProductIdRequired = !!requestParams.related_product_id_required;
                    if ((!colourTagRequired || colourID) && (!relatedProductIdRequired || relatedProductID)) {
                        const queryParams = requestParams.query_params ? siteHelper.simpleCloneObject(requestParams.query_params) : {};
                        const tags = requestParams.tags ? requestParams.tags.slice() : [];
                        const colourParamExpected = !!requestParams.colour_param_expected;
                        const styleParamExpected = !!requestParams.style_param_expected;
                        let tagsModeAny = false;
                        for (let key in queryParams) {
                            if (key.toLowerCase() === "tags_mode" && queryParams[key].toLowerCase() === "any") {
                                tagsModeAny = true;
                            }
                        }
                        if (colourParamExpected && colourID) {
                            queryParams.colour = colourID;
                        }
                        if (styleParamExpected && styleID) {
                            queryParams.style = styleID;
                        }
                        if (relatedProductIdRequired) {
                            queryParams.related_product = relatedProductID;
                        }
                        if (colourTagRequired) {
                            if (!tagsModeAny || tags.length < 2) {
                                tags.push(colourID);
                            } else {
                                filterByColourRequired = true;
                            }
                        }
                        if (tags.length) {
                            queryParams.tags = tags;
                        }
                        let queryString = "";
                        for (let key in queryParams) {
                            if (!queryString) {
                                queryString += "?";
                            } else {
                                queryString += "&";
                            }
                            queryString += key + "=" + queryParams[key];
                        }
                        requestEndpoint = '/request/api.php/ranges/' + requestRangeID + '/products/' + apiCode + queryString;
                    }
                }
            }
        }

        model.base_component_id = baseComponentID;
        model.parent_category_group_id = parentCategoryGroupID;
        model.parent_category_group_type_id = parentCategoryGroupTypeID;
        model.parent_category_id = parentCategoryID;
        model.request_range_id = requestRangeID;
        model.colour_id = colourID;
        model.style_id = styleID;
        model.site_range_id = siteRangeID;
        model.base_component_cache = baseComponentCache;
        model.parent_category_group_cache = parentCategoryGroupCache;
        model.parent_category_cache = parentCategoryCache;
        model.request_endpoint = requestEndpoint;
        model.api_code = apiCode;
        model.filter_by_colour_required = filterByColourRequired;
    }

    this.resetSelection = function (product) {
        product.selection_values = {};
        for (let selectionID in product.selection_inputs) {
            const selectionInput = product.selection_inputs[selectionID];
            if (selectionInput.defaultDisabled) {
                selectionInput.disabled = true;
            }

            if (selectionInput.default_value) {
                product.selection_values[selectionID] = selectionInput.default_value;
            }
        }
    }

    this.resetProduct = function (product) {
        product.quantity = 1;

        product.option_product_model = null;
        if (product.small_product) {
            product.small_product.option_product_model = null;
        }
        if (product.large_product) {
            product.large_product.option_product_model = null;
        }
        product.option_term_ids = {};
        product.option_term_values = {};

        service.resetSelection(product);


        const optionTermModels = product.getOptionProductModel().term_models;
        for (let optionID in optionTermModels) {
            const optionTermModel = optionTermModels[optionID];
            optionTermModel.applyResetState(product);
        }

        if (product.hasOwnProperty('drill_0') && !product.drill_save) {
            product.drillside = '';
            product.drill_0 = '';
            product.drill_1 = '';
            product.drill_2 = '';
            product.drill_3 = '';
            product.drill_4 = false;
            product.drill_5 = false;
        }
    }

    this.getHingeHoleOptions = function (product, noneValue) {

        if (!product.hinge_hole_sides) {
            return null;
        }
        const hingeHoleOptions = [];
        for (let i = 0; i < product.hinge_hole_sides.length; i++) {
            let optionName = ""
            const hingeHoleSide = product.hinge_hole_sides[i];
            switch (hingeHoleSide) {
                case "none":
                    optionName = noneValue ? noneValue : "Undrilled (Hinges not Supplied)";
                    break;
                case "left":
                    optionName = "Left";
                    break;
                case "right":
                    optionName = "Right";
                    break;
                case "left_and_right":
                    optionName = "Drill Both Sides";
                    break;
                case "top":
                    optionName = "Top Hung";
                    break;
                case "bottom":
                    optionName = "Bottom Hung";
                    break;
                default:
                    break;
            }

            hingeHoleOptions.push({
                value: hingeHoleSide,
                name: optionName
            });
        }
        return hingeHoleOptions;
    }

    this.collectHingeHoles = function (product, nullIfEmpty) {


        const fromTop = [];
        const fromBottom = [];

        if (product.timber_drill) {

            fromTop.push(product.timber_drill);
            fromBottom.push(product.timber_drill);

        } else {

            if (siteHelper.isNumber(product.drill_0)) {
                fromTop.push(product.drill_0);
            }

            if (siteHelper.isNumber(product.drill_1)) {
                fromTop.push(product.drill_1);
            }

            if (siteHelper.isNumber(product.drill_2)) {
                fromBottom.push(product.drill_2);
            }

            if (siteHelper.isNumber(product.drill_3)) {
                fromBottom.push(product.drill_3);
            }

        }
        if (nullIfEmpty && !product.drillside && fromTop.length === 0 && fromBottom.length === 0) {
            return null;
        }

        return {
            "side": product.drillside ? product.drillside : "none",
            "from_start": fromTop,
            "from_end": fromBottom,
            "centre": product.drill_4,
            "two_centre": product.drill_5
        }
    }

    function userProductDiscounts(product) {
        const customerData = $rootScope.model.account.customer_data;
        if (!customerData) {
            return null;
        }
        if (!customerData.discounts) {
            return null;
        }
        const discounts = customerData.discounts[product.discount_group];
        return discounts ? discounts : null;
    }

    function discountPrice(product, productPrice) {

        const discounts = userProductDiscounts(product);
        if (!discounts) {
            return productPrice;
        }
        return productPrice - (discounts.discount / 100) * productPrice;
    }


    this.appliedMinimumDiscountPrice = function (product, productPrice) {
        const productDiscountPrice = discountPrice(product, productPrice);

        // check if has min price and if calculated price is less than min
        if (product.minimum_price) {
            if (productDiscountPrice < product.minimum_price) {
                return product.minimum_price;
            }
        }

        return productDiscountPrice;
    }

    this.calculatePrice = function (product) {

        if (!$rootScope.model.account.customer_data) {
            return 0;
        }

        // start with the base price for the product, direct from api, it should be unaltered!
        let totalPrice = product.base_price;

        // check for price by 3d area for wrapped panels
        if (product.height && product.width && product.depth) {

            if (product.return) {
                totalPrice = ((product.height * (product.width + product.depth * 2 + product.return * 2)) * product.base_price) / 1000000;
            } else {
                totalPrice = ((product.height * (product.width + product.depth * 2)) * product.base_price) / 1000000;
            }

        }
        // check for price by area
        if (product.depth && product.length) {
            totalPrice = ((product.depth * product.length) * product.base_price) / 1000000;
        }

        // check for diameter calculation
        if (product.diameter) {
            totalPrice = ((product.diameter * product.diameter) * product.base_price) / 1000000;
        }

        let productSurcharge = 0;

        //pronto has no surcharges, so just set it to 0
        if (product.request_range_id === "pronto" || product.current_surcharge === undefined) {
            product.current_surcharge = 0;
        }


        // apply any product specific surcharge
        if ((product.depth && product.length) || product.diameter) {
            totalPrice += (product.current_surcharge / 100) * totalPrice;
        } else {
            totalPrice += (product.current_surcharge / 100) * product.base_price;
        }

        const complexOption = $rootScope.service.option_product.currentComplexOption(product);
        // there are options check for surcharges and fixed costs
        if (product.options) {
            if (product.range === "bella") {
                // add the option surcharge
                productSurcharge += (complexOption.surcharge / 100) * totalPrice;

            } else if (['zurfiz', 'valore'].includes(product.range)) {
                productSurcharge += ($rootScope.navigation_model.state_values.colour_surcharge / 100) * totalPrice;
            }

        }

        totalPrice += productSurcharge;
        productSurcharge = 0;

        // add the fixed cost for the selected option
        totalPrice += complexOption.fixed_cost;

        if (product.range === "bella") {
            if ((product.depth && product.length) || product.diameter) {
                if (product.apply_colour_surcharge) {
                    productSurcharge += ($rootScope.navigation_model.state_values.colour_surcharge / 100) * totalPrice;
                }
                if (product.apply_style_surcharge) {
                    productSurcharge += ($rootScope.navigation_model.state_values.style_surcharge / 100) * totalPrice;
                }
            } else {
                if (product.apply_colour_surcharge) {
                    productSurcharge += ($rootScope.navigation_model.state_values.colour_surcharge / 100) * product.base_price;
                }
                if (product.apply_style_surcharge) {
                    if (!$rootScope.navigation_model.state_values.style_minimum_surcharge_height || product.height >= $rootScope.navigation_model.state_values.style_minimum_surcharge_height) {
                        productSurcharge += ($rootScope.navigation_model.state_values.style_surcharge / 100) * product.base_price;
                    }
                }
            }
        }

        // Apply the surcharge
        totalPrice += productSurcharge;

        //non standard surcharge first! WTF  are "customer-specific surcharges"?

        if (product.applynonstdsurcharge) {
            totalPrice += (product.current_non_standard_surcharge / 100) * totalPrice;
        }

        return totalPrice;
    };

    this.finalPrice = function (product) {
        const calculatedPrice = service.calculatePrice(product);
        return service.appliedMinimumDiscountPrice(product, calculatedPrice);
    }

    this.addToCart = function (orderBuild, callback, orderBuildOnly) {


        const currentOrder = $rootScope.model.order.current_order;
        const userData = $rootScope.model.account.user_data;
        const customerData = $rootScope.model.account.customer_data;
        const stateIDs = $rootScope.navigation_model.state_ids;

        if (!userData.webquote_defaults) {
            userData.webquote_defaults = {};
            userData.webquote_defaults.margin = 0;
            userData.webquote_defaults.discount = 0;
        }

        if (orderBuild.lines) {
            for (let i = 0; i < orderBuild.lines.length; i++) {
                const orderLine = orderBuild.lines[i];
                orderLine.quote_margin = userData.webquote_defaults.margin;
                orderLine.quote_discount = userData.webquote_defaults.discount;
                if (!orderLine.state_ids) {
                    orderLine.state_ids = stateIDs;
                }
            }
        }

        if (currentOrder.type === undefined) {
            currentOrder.type = "weborder";
        }

        orderBuild.weborder = true;
        orderBuild.type = currentOrder.type;
        orderBuild.customer_code = $rootScope.service.account.getCustomerCode();
        orderBuild.reference = "testorder";
        orderBuild.despatch_type = "standard";
        orderBuild.currency = customerData.currencyData.id;
        orderBuild.payment_type = "account";
        orderBuild.collection = false;


        console.log("orderBuild")
        console.log(orderBuild)

        $http({
            url: '/request/api.php/orders/build',
            method: "POST",
            data: orderBuild,
            headers: {
                "Content-Type": "application/json"
            }
        })
            .then(function (response) {
                    const responseData = response.data;

                    if (responseData.redirectlogin) {
                        didLogOut = true;
                        window.location = "/logout.php?login=1"
                        return;
                    }
                    handleCartResponse(responseData, callback, orderBuildOnly);
                },
                function (data, status, headers, config) { // optional
                    // failed

                    if (didLogOut) {
                        return;
                    }
                    if (status === 401) {
                        didLogOut = true;
                        $rootScope.model.account.is_login_required = true;
                        window.location.reload();
                        return;
                    }
                    handleCartResponse(null, callback, orderBuildOnly);
                });
    }

    this.getOrderLineErrors = function (orderLine) {
        const errors = [];

        if (orderLine._errors) {
            if (!siteHelper.isArray(orderLine._errors)) {
                errors.push(orderLine._errors);
            } else {
                for (let i = 0; i < orderLine._errors.length; i++) {
                    const error = orderLine._errors[i];
                    errors.push(error);

                }
            }
        }

        if (orderLine._sublines) {
            for (let i = 0; i < orderLine._sublines.length; i++) {
                if (orderLine._sublines[i]._errors) {
                    for (let j = 0; j < orderLine._sublines[i]._errors.length; j++) {
                        const error = orderLine._sublines[i]._errors[j];
                        errors.push(error);
                    }
                }
            }
        }
        return errors;
    }

    function handleCartResponse(orderBuild, callback, orderBuildOnly) {

        let i, j, error;
        const messages = [];

        function addError(message) {
            messages.push({
                type: 'danger',
                msg: 'An error has occurred!' + (message ? ' ERROR - ' + message : '')
            });
        }

        let success = false;
        let orderLine = null;
        let haveErrorMessage = false;
        let haveErrorLines = false;
        console.log("response")
        console.log(orderBuild)

        if (orderBuild) {
            orderLine = orderBuild.lines ? orderBuild.lines[0] : null;
            haveErrorMessage = !!orderBuild.error;
            haveErrorLines = !!orderBuild._errors && !!orderBuild._errors.lines;
        }

        if (haveErrorMessage && !haveErrorLines) {

            addError(orderBuild.message);

        } else if (!orderLine) {

            addError(null);

        } else if (haveErrorLines) {
            const errors = service.getOrderLineErrors(orderLine);
            for (i = 0; i < errors.length; i++) {
                addError(errors[i]);
            }
        } else {

            success = true;

            if (!orderLine._description) {
                console.warn("No _description for")
                console.warn(orderLine)
            }

            if (!orderBuildOnly) {

                if (orderLine._description && !orderLine.description) {
                    orderLine.description = orderLine._description;
                }

                if(orderBuild.category_cache){
                    $rootScope.model.order.current_order.category_cache = orderBuild.category_cache;
                }
                $rootScope.model.order.current_order.lines.unshift(orderLine);
                $rootScope.service.order.saveOrder();

                messages.push({
                    type: 'success',
                    msg: 'Product added to your cart.'
                });
                console.log("added to cart")
                $rootScope.service.tracking.track_event("Cart", "Added to cart");
            }

        }

        if (callback) {
            callback(success, messages, orderLine, orderBuild);
        }
    }

}])